angular.module('bmsApp.trugreen', [
	'bmsApp.trugreen.quote',
	'bmsApp.trugreen.product',
	'bmsApp.trugreen.visitplanner',
	'bmsApp.trugreen.job',
	'bmsApp.trugreen.schedule',
	'bmsApp.trugreen.inventory',
	'bmsApp.trugreen.bulkPriceUpdate',
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.trugreen', {
					abstract: true,
					url: '/trugreen'
				})

			;
		}]);
